export default "__VITE_ASSET__65b4151b__"